function getTagalysHeaderThemeSchema(headerThemeConfig) {
  headerThemeConfig = headerThemeConfig || {}
  const { badge_map, theme_style } = headerThemeConfig

  const SEARCH_SELECTORS = {
    input: '.header-v2-search__input',
    recommendations: "[data-widget='recommendations']",
    searchDetails: 'header-search-details',
    searchSchemaPages: '.search-schema-pages',
    suggestionsAnchor: '.header-search__suggestions-anchor',
    tagalysSuggestionsAnchor:
      '.header-search__suggestions-anchor#tagalys-namespace',
    viewAllButton: '.search-viewall-btn',
  }

  var isShopifySuggestionsFailover = false

  const HeaderSearchController = {
    init: function () {
      this.initTagalysReorder()
      this.initSidebarState()
    },

    getElements: function () {
      return {
        recommendations: document.querySelector(
          SEARCH_SELECTORS.recommendations
        ),
        searchDetails: document.querySelector(SEARCH_SELECTORS.searchDetails),
        searchSchemaPages: document.querySelector(
          SEARCH_SELECTORS.searchSchemaPages
        ),
        viewAllButton: document.querySelector(SEARCH_SELECTORS.viewAllButton),
      }
    },

    initTagalysReorder: function () {
      var anchor = document.querySelector(SEARCH_SELECTORS.suggestionsAnchor)
      if (!anchor) return

      if (anchor.dataset.reorderInitialized === 'true') return
      anchor.dataset.reorderInitialized = 'true'

      function moveTargetToTop() {
        var target = null

        for (var index = 0; index < anchor.children.length; index += 1) {
          var child = anchor.children[index]

          if (
            child.id === 'tagalys-namespace' &&
            child.getAttribute('data-widget') !== 'recommendations'
          ) {
            target = child
            break
          }
        }

        if (target && anchor.firstElementChild !== target) {
          anchor.prepend(target)
        }
      }

      var observer = new MutationObserver(function () {
        moveTargetToTop()
      })

      observer.observe(anchor, { childList: true })
      moveTargetToTop()
    },

    initSidebarState: function () {
      var elements = this.getElements()
      var searchDetails = elements.searchDetails
      if (!searchDetails) return

      var observer = new MutationObserver(function () {
        if (searchDetails.hasAttribute('open')) {
          document.body.style.overflow = 'hidden'
          return
        }

        document.body.style.overflow = ''
        HeaderSearchController.resetSidebarContent()
      })

      observer.observe(searchDetails, {
        attributes: true,
        attributeFilter: ['open'],
      })
    },

    resetSidebarContent: function () {
      if (isShopifySuggestionsFailover) {
        this.hideDefaultContent()
        return
      }

      var elements = this.getElements()
      if (
        !elements.recommendations ||
        !elements.viewAllButton ||
        !elements.searchSchemaPages
      )
        return

      elements.recommendations.style.display = 'block'
      elements.viewAllButton.style.display = 'flex'
      elements.searchSchemaPages.style.display = 'block'

      var noResultsMessage = elements.recommendations.querySelector(
        '.no-results-message'
      )
      if (noResultsMessage) {
        noResultsMessage.style.display = 'none'
      }
    },

    hideDefaultContent: function () {
      var elements = this.getElements()

      if (elements.recommendations) {
        elements.recommendations.style.display = 'none'
      }
      if (elements.viewAllButton) {
        elements.viewAllButton.style.display = 'none'
      }
      if (elements.searchSchemaPages) {
        elements.searchSchemaPages.style.display = 'none'
      }
    },

    checkTypeSuggestionAvailable: function (helpers) {
      var container = document.querySelector(
        SEARCH_SELECTORS.tagalysSuggestionsAnchor +
          ' .product-and-text-suggestions'
      )

      if (!container || !helpers) return

      var products =
        typeof helpers.getProducts === 'function' ? helpers.getProducts() : []
      var isAvailable = Array.isArray(products) && products.length > 0

      container.classList.toggle('search-typed-suggestions-hide', !isAvailable)
    },
  }

  HeaderSearchController.init()

  function escapeHtml(value) {
    var div = document.createElement('div')
    div.textContent = value || ''
    return div.innerHTML
  }

  const SearchUIController = (function () {
    var fallbackMinChars = 2
    var state = {
      minChars: null,
    }
    var boundInput = null

    function normalizeMinChars(value) {
      if (value === null || value === undefined || value === '') return null

      var minChars = Number(value)
      return Number.isFinite(minChars) && minChars >= 0 ? minChars : null
    }

    function getWidgetOptions(helpers) {
      if (!helpers || typeof helpers.getTemplateOptions !== 'function')
        return {}

      try {
        return helpers.getTemplateOptions('widget') || {}
      } catch (error) {
        return {}
      }
    }

    function resolveMinChars(source, helpers) {
      source = source || {}

      var widgetOptions = getWidgetOptions(helpers)
      var sourceState = source.state || {}
      var candidates = [
        sourceState.minimumCharactersToShowSuggestions,
        source.minimumCharactersToShowSuggestions,
        source.minChars,
        widgetOptions.minimumCharactersToShowSuggestions,
        state.minChars,
        fallbackMinChars,
      ]

      for (var index = 0; index < candidates.length; index += 1) {
        var minChars = normalizeMinChars(candidates[index])
        if (minChars !== null) return minChars
      }

      return fallbackMinChars
    }

    function syncMinChars(source, helpers) {
      state.minChars = resolveMinChars(source, helpers)
      return state.minChars
    }

    function getElements() {
      return {
        input: document.querySelector(SEARCH_SELECTORS.input),
        recommendationContainer: document.querySelector(
          SEARCH_SELECTORS.recommendations
        ),
        searchSchemaPages: document.querySelector(
          SEARCH_SELECTORS.searchSchemaPages
        ),
        viewAllbtn: document.querySelector(SEARCH_SELECTORS.viewAllButton),
      }
    }

    function computeState(helpers, source) {
      var minChars = syncMinChars(source, helpers)
      var query =
        helpers && typeof helpers.getEnteredSearchQuery === 'function'
          ? helpers.getEnteredSearchQuery()
          : ''
      var inputLength = query.trim().length

      var products =
        helpers && typeof helpers.getProducts === 'function'
          ? helpers.getProducts()
          : []
      var hasProducts = Array.isArray(products) && products.length > 0

      return {
        query,
        inputLength,
        hasProducts,
        isShortInput: inputLength < minChars,
      }
    }

    function toggleVisibility(elements, show) {
      if (isShopifySuggestionsFailover) {
        show = false
      }

      if (elements.recommendationContainer) {
        elements.recommendationContainer.style.display = show ? '' : 'none'
      }
      if (elements.searchSchemaPages) {
        elements.searchSchemaPages.style.display = show ? '' : 'none'
      }
      if (elements.viewAllbtn) {
        elements.viewAllbtn.style.display = show ? '' : 'none'
      }
    }

    function handleNoResults(elements, computed) {
      var container = elements.recommendationContainer
      if (!container) return

      var existing = container.querySelector('.no-results-message')

      if (computed.isShortInput || computed.hasProducts) {
        if (existing) existing.remove()
        return
      }

      var messageEl = existing || document.createElement('div')
      messageEl.className = 'no-results-message'
      messageEl.style.display = ''
      messageEl.innerHTML = `
        No results for "<strong>${escapeHtml(computed.query)}</strong>".<br/>
        Try checking your spelling or use different keywords.
      `

      if (!existing) container.prepend(messageEl)
    }

    function handleAfterRender(helpers, source) {
      var elements = getElements()
      if (!helpers || !elements.input || !elements.recommendationContainer)
        return

      var computed = computeState(helpers, source)

      if (computed.isShortInput || computed.hasProducts) {
        var oldMsg = elements.recommendationContainer.querySelector(
          '.no-results-message'
        )
        if (oldMsg) oldMsg.remove()
      }
    }

    function handleAPIResponse(helpers, source) {
      var elements = getElements()
      if (!helpers || !elements.input) return

      var computed = computeState(helpers, source)

      var shouldShow = computed.isShortInput || !computed.hasProducts

      toggleVisibility(elements, shouldShow)
      handleNoResults(elements, computed)
    }

    function handleBeforeAPI(helpers, source) {
      var elements = getElements()
      syncMinChars(source, helpers)

      var exceedsMinimum = null
      if (
        helpers &&
        typeof helpers.exceedsMinimumCharactersToShowSuggestions === 'function'
      ) {
        exceedsMinimum = helpers.exceedsMinimumCharactersToShowSuggestions()
      }

      var shouldHide =
        typeof exceedsMinimum === 'boolean'
          ? exceedsMinimum
          : elements.input &&
            elements.input.value.trim().length >= state.minChars

      if (shouldHide) {
        toggleVisibility(elements, false)
      }
    }

    function bindInputListener(source, helpers) {
      var elements = getElements()
      if (!elements.input) return
      if (boundInput === elements.input) return

      boundInput = elements.input
      elements.input.addEventListener('input', function () {
        syncMinChars(source, helpers)
        var isShort = elements.input.value.trim().length < state.minChars
        toggleVisibility(elements, isShort)
      })
    }

    function init(source, helpers) {
      syncMinChars(source, helpers)
      bindInputListener(source, helpers)
    }

    function restructureSuggestionsDOM() {
      var container = document.querySelector(
        SEARCH_SELECTORS.suggestionsAnchor +
          ' .search-suggestions .product-and-text-suggestions'
      )

      if (!container) return

      var recomm = container.querySelector('.search-recomm-typed-products')
      var popular = container.querySelector(
        '[data-section-id="popular_searches"]'
      )

      if (!recomm || !popular) return

      // already moved
      if (popular.dataset.moved) return

      // no items
      if (!popular.querySelector('li')) return

      var newList = document.createElement('ul')
      newList.className = 'text-suggestions'

      newList.appendChild(popular)
      recomm.parentNode.insertBefore(newList, recomm)

      popular.dataset.moved = 'true'
    }

    return {
      init,
      handleAfterRender,
      handleAPIResponse,
      handleBeforeAPI,
      restructureSuggestionsDOM,
    }
  })()

  onTagalysReady(function () {
    var inputElement = document.querySelector(SEARCH_SELECTORS.input)
    if (!inputElement) {
      console.error('Search input (.header-v2-search__input) not found')
      return
    }

    var searchSuggestionsConfig = {
      searchResultsURL: '/pages/search-results',
      templates: {
        widget: {
          options: {
            selector: SEARCH_SELECTORS.suggestionsAnchor,
            alignToSelector: SEARCH_SELECTORS.suggestionsAnchor,
            interactionSelectors: [
              '#main',
              '#shopify-section-header-v2',
              '.ldt-cp-App-Content',
              '.ldt-cp-Modal',
              '.ldt-cp-Modal__Footer',
            ],
            sections: {
              products: {
                include: ['total_count', 'items'],
                count: 12,
              },
              pages: {
                count: 10,
              },
              popular_searches: {
                count: 10,
              },
            },
          },
        },

        clickSuggestions: {
          render: function (html, args) {
            if (isShopifySuggestionsFailover) {
              return html``
            }

            var helpers = args.props?.helpers
            var recentAndPopularSearches =
              helpers?.getRecentAndPopularSearches?.() || {}
            var popularSearches = recentAndPopularSearches.popularSearches || []

            if (!popularSearches.length) {
              return html``
            }

            return html`
              <div class="default-suggestion">
                <div
                  class="default-suggestion-heading"
                  role="heading"
                  aria-level="3"
                >
                  Popular searches
                </div>
                <header-search-suggestion-scroller
                  class="click-search-suggestion-wrapper"
                >
                  <ul class="click-suggestions js-search-horizontal-scroll">
                    ${popularSearches.map(function (popularSearch) {
                      return html`<${args.templates.popularSearchItem}
                        popularSearch=${popularSearch}
                      />`
                    })}
                  </ul>
                  <button class="scroll-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M9.75 7.5L14.25 12L9.75 16.5"
                        stroke="white"
                        stroke-width="1.5"
                      />
                    </svg>
                  </button>
                </header-search-suggestion-scroller>
              </div>
            `
          },
        },

        typeSuggestions: {
          render: function (html, args) {
            var props = args.props || {}
            var helpers = props.helpers
            var textSuggestions = helpers?.getTextSuggestions?.() || []
            var hasTextSuggestions = helpers?.hasTextSearchSuggestions?.() > 0

            var classes = ['type-suggestions']
            if (hasTextSuggestions) {
              classes.push('product-and-text-suggestions')
            } else {
              classes.push('product-suggestions')
            }
            var className = classes.join(' ')

            return html` <div class=${className}>
              <${args.templates.products} class="product-suggestions" />

              ${hasTextSuggestions
                ? html` <ul class="text-suggestions">
                    ${textSuggestions.map(function (textSuggestionSection) {
                      return html`
                        <${args.templates.textSuggestionSection}
                          textSuggestionSection=${textSuggestionSection}
                        />
                      `
                    })}
                  </ul>`
                : null}
            </div>`
          },
        },

        textSuggestionSection: {
          render: function (html, args) {
            var props = args.props || {}
            var textSuggestionSection = props.textSuggestionSection || {}
            var textSuggestionItems = textSuggestionSection.items || []

            var title = textSuggestionSection.title
              ? textSuggestionSection.title.toLowerCase().trim()
              : ''

            if (textSuggestionItems.length > 0) {
              return html`
                <li
                  class="text-suggestion-section"
                  data-section-id=${textSuggestionSection.id}
                >
                  <span class="section-title" role="heading" aria-level="3">
                    ${textSuggestionSection.title === 'Popular searches'
                      ? 'Related searches'
                      : textSuggestionSection.title}
                  </span>

                  ${title === 'pages'
                    ? html`
                        <search-pages-carousel>
                          <div
                            class="splide js-pages-carousel js-carousel-container"
                          >
                            <div class="splide__track">
                              <ul class="splide__list">
                                ${textSuggestionItems.map(function (item) {
                                  return html`
                                    <li class="splide__slide">
                                      <div class="search-schema-page-default">
                                        <div
                                          class="search-schema-page-text-wrapper"
                                        >
                                          <h4>${item.title}</h4>
                                        </div>

                                        <div
                                          class="search-schema-page-default-link"
                                        >
                                          <a href=${item.link}>
                                            Read more
                                            <span
                                              class="search-schema-page-default-link-arrow"
                                              >→</span
                                            >
                                          </a>
                                        </div>
                                      </div>
                                    </li>
                                  `
                                })}
                              </ul>
                            </div>

                            <div
                              class="splide__arrows product-card__media-splide-arrows"
                            >
                              <button
                                type="button"
                                class="splide__arrow splide__arrow--prev button button--action-circle product-card__media-splide-arrow"
                              >
                                <svg width="12" height="12" viewBox="0 0 12 12">
                                  <use xlink:href="#icon-arrow-left"></use>
                                </svg>
                              </button>

                              <button
                                type="button"
                                class="splide__arrow splide__arrow--next button button--action-circle product-card__media-splide-arrow"
                              >
                                <svg width="12" height="12" viewBox="0 0 12 12">
                                  <use xlink:href="#icon-arrow-right"></use>
                                </svg>
                              </button>
                            </div>
                          </div>
                        </search-pages-carousel>
                      `
                    : html` <header-search-suggestion-scroller
                        class="text-suggestion-section-wrapper"
                      >
                        <ul
                          class="text-suggestion-section-list js-search-horizontal-scroll"
                        >
                          ${textSuggestionItems.map(
                            function (textSuggestionSectionItem) {
                              return html`
                                <${args.templates.textSuggestionSectionItem}
                                  textSuggestionSectionId=${textSuggestionSection.id}
                                  textSuggestionSectionItem=${textSuggestionSectionItem}
                                />
                              `
                            }
                          )}
                        </ul>
                        <button class="scroll-right">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M9.75 7.5L14.25 12L9.75 16.5"
                              stroke="white"
                              stroke-width="1.5"
                            />
                          </svg>
                        </button>
                      </header-search-suggestion-scroller>`}
                </li>
              `
            }

            return null
          },
        },

        popularSearchItem: {
          render: function (html, args) {
            var props = args.props || {}
            var helpers = props.helpers
            var query = props.popularSearch?.query || ''
            var enteredSearchQuery = helpers?.getEnteredSearchQuery?.() || ''

            if (!query) {
              return null
            }

            return html`
              <li>
                <a
                  class="search-results-link"
                  href=${helpers?.getLink?.(query) ||
                  '/pages/search-results?query=' + encodeURIComponent(query)}
                >
                  <${args.templates.highlighter}
                    label=${query}
                    highlight=${enteredSearchQuery}
                  />
                </a>
              </li>
            `
          },
        },

        hint: {
          render: function () {
            return null
          },
        },

        products: {
          render: function (html, args) {
            var props = args.props || {}
            var helpers = props.helpers
            var products = helpers?.getProducts?.() || []
            if (!Array.isArray(products)) {
              products = []
            }
            var libraryState = helpers?.getLibraryState?.()
            var apiResponse = helpers?.getAPIResponse?.()
            var enteredQuery = libraryState ? libraryState.enteredQuery : ''
            var totalCount =
              apiResponse &&
              apiResponse.sections &&
              apiResponse.sections.products
                ? apiResponse.sections.products.total_count
                : 0

            return html`
              <div class="search-recomm-typed-products">
                <div
                  class="search-recomm-typed-product-heading"
                  role="heading"
                  aria-level="3"
                >
                  Products
                </div>
                <div
                  role="group"
                  aria-label=""
                  class=${`products ${props.className || ''} splide`}
                >
                  ${products.map(function (product) {
                    return html`
                      <${args.templates.product}
                        key=${product.id}
                        product=${product}
                        total_count=${totalCount}
                      />
                    `
                  })}
                </div>

                <div class="typed-search-viewall-btn">
                  <a
                    href=${'/pages/search-results?query=' +
                    encodeURIComponent(enteredQuery)}
                  >
                    View all results (${totalCount}) +
                  </a>
                </div>
              </div>
            `
          },
        },

        product: {
          callbacks: {
            afterInitialRender: function (helpers, props) {
              if (
                window.yotpo &&
                typeof window.yotpo.initWidgets === 'function'
              ) {
                window.yotpo.initWidgets()
              }

              if (
                typeof window.yotpoWidgetsContainer?.initWidgets === 'function'
              ) {
                window.yotpoWidgetsContainer?.initWidgets()
              }
            },
          },

          render: function (html, args) {
            var { product, helpers } = args.props
            const images = product.images?.slice(0, 3) || []

            const productUrl = helpers
              .getTemplateOptions('product')
              .productPageUrl(product)

            /* ✅ SAFE SPLIT FUNCTION */
            const splitTitle = (title, value) => {
              if (!value) return { before: title, after: '' }

              // escape + flexible spacing
              const escaped = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
              const flexible = escaped.replace(/\s+/g, '\\s?')

              const regex = new RegExp(`(.*?)\\b${flexible}\\b(.*)`, 'i')
              const match = title.match(regex)

              if (!match) {
                return { before: title, after: '' }
              }

              return {
                before: match[1].trim(),
                after: match[2].trim(),
              }
            }

            let cleanTitle = product.title
            let productSubtitle = ''

            const caseDiameter =
              product.metafields?.specs?.case_diameter?.value?.[0]
            const bandMaterial =
              product.metafields?.specs?.band_material?.value?.[0]

            /* ✅ PRIORITY 1: case_diameter */
            if (caseDiameter) {
              const { before, after } = splitTitle(product.title, caseDiameter)

              cleanTitle = before

              if (!after || before === after) {
                productSubtitle = caseDiameter
              } else {
                productSubtitle = `${caseDiameter} ${after}`.trim()
              }
            } else if (bandMaterial) {
              /* ✅ PRIORITY 2: band_material */
              const { before, after } = splitTitle(product.title, bandMaterial)

              cleanTitle = before

              if (!after || before === after) {
                productSubtitle = bandMaterial
              } else {
                productSubtitle = `${bandMaterial} ${after}`.trim()
              }
            }

            const colorsCount =
              (product.metafields?.merchandise?.variants?.value?.length || 0) >
              0
                ? product.metafields.merchandise.variants.value.length + 1
                : 0

            const isDesktop = window.innerWidth >= 990

            return html`
              <div class="product-card">
                <div
                  class="search-landing__results-item product-card__media-wrapper exclude-tagalys-css-reset"
                >
                  ${(() => {
                    const badgeEntries = Object.entries(badge_map || {})
                      .map(([key, value]) => ({
                        key,
                        ...value,
                      }))
                      .sort((a, b) => (a.priority || 0) - (b.priority || 0))

                    const badges = []
                    let badgeCount = 0

                    for (const badge of badgeEntries) {
                      if (badgeCount >= 2) break

                      const hasTag = product.tags?.includes(badge.tag_reference)

                      if (!hasTag) continue

                      badges.push(html`
                        <div
                          class="product-badge__item utility exclude-tagalys-css-reset"
                          id="product-badge-${badge.key}"
                          style="
          --badge-font-color:${badge.color};
          --badge-border-color:${badge.border_color};
          ${badge.background_color
                            ? `--badge-background-color:${badge.background_color};`
                            : ''}
        "
                        >
                          ${badge.label
                            ? html`
                                <span class="product-badge__label"
                                  >${badge.label}</span
                                >
                              `
                            : ''}
                          ${badge.icon
                            ? html`
                                <span
                                  class="${badge.label
                                    ? 'product-badge__icon'
                                    : 'product-badge__icon product-badge__icon--no-label'}"
                                  style="
                  -webkit-mask:url(${badge.icon}) no-repeat center / contain;
                  mask:url(${badge.icon}) no-repeat center / contain;
                  background-color:${badge.color};
                  width:${badge.label ? 12 : 35}px;
                  height:${badge.label ? 12 : 35}px;
                  display:inline-block;
                "
                                >
                                  <span style="opacity:0;">
                                    <img
                                      src="${badge.icon}"
                                      width="${badge.label ? 12 : 35}"
                                      height="${badge.label ? 12 : 35}"
                                    />
                                  </span>
                                </span>
                              `
                            : ''}
                        </div>
                      `)

                      badgeCount++
                    }

                    if (!badges.length) return ''

                    return html`
                      <div
                        class="search-product-badge exclude-tagalys-css-reset"
                      >
                        ${badges}
                      </div>
                    `
                  })()}

                  <!-- SPLIDE START -->
                  <search-image-carousel>
                    <div
                      class="splide product-card__media-splide js-carousel-container"
                      role="group"
                      id="splide-${product.id}"
                    >
                      ${images.length > 1
                        ? html`
                            <ul
                              class="splide__pagination product-card__media-splide-pagination"
                            ></ul>
                          `
                        : ''}

                      <div class="splide__track">
                        <ul class="splide__list search-recomm-product-list">
                          ${images.map((image, index) => {
                            const isPng = /\.png(\?|$)/i.test(image.src)
                            const imgClass = isPng
                              ? 'product-card__image'
                              : 'product-card__image product-card__image-jpg'

                            const loading = index === 0 ? 'eager' : 'lazy'

                            return html`
                              <li
                                class="splide__slide"
                                key="${product.id}-${image.position}"
                              >
                                <a
                                  id="product-${product.id}-${image.position}"
                                  href="${productUrl}"
                                  aria-label="${image.alt || product.title}"
                                  data-product-card-link
                                >
                                  <div
                                    class="product-card__image-wrapper exclude-tagalys-css-reset"
                                  >
                                    <img
                                      src="${image.src}"
                                      width="400"
                                      height="500"
                                      class="${imgClass}"
                                      loading="${loading}"
                                      alt="${image.alt || product.title}"
                                    />
                                  </div>
                                </a>
                              </li>
                            `
                          })}
                        </ul>
                      </div>

                      <div
                        class="splide__arrows product-card__media-splide-arrows 
                            ${images?.length > 1
                          ? ''
                          : 'product-card__media-splide-arrows-hide'}"
                      >
                        <button
                          type="button"
                          class="splide__arrow splide__arrow--prev button button--action-circle product-card__media-splide-arrow"
                          aria-label="Previous"
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            aria-hidden="true"
                          >
                            <use
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              xlink:href="#icon-arrow-left"
                            ></use>
                          </svg>
                        </button>
                        <button
                          type="button"
                          class="splide__arrow splide__arrow--next button button--action-circle product-card__media-splide-arrow"
                          aria-label="Next"
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            aria-hidden="true"
                          >
                            <use
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              xlink:href="#icon-arrow-right"
                            ></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </search-image-carousel>
                  <!-- SPLIDE END -->

                  <div
                    class=${isDesktop
                      ? 'product-card__compare-holder'
                      : 'product-card__compare-holder--mobile'}
                  ></div>
                </div>

                <div class="product-card__details">
                  <a
                    class="search-landing__product-card-title exclude-tagalys-css-reset"
                  >
                    ${cleanTitle}
                  </a>
                  ${productSubtitle
                    ? html`<div
                        class="search-landing__product-card__subtitle exclude-tagalys-css-reset"
                      >
                        ${productSubtitle}
                        ${theme_style === 'guess' &&
                        colorsCount &&
                        !Number.isNaN(colorsCount)
                          ? ` | ${colorsCount} Colors`
                          : ''}
                      </div>`
                    : ''}

                  <div
                    class="search-landing__product-card-price exclude-tagalys-css-reset"
                  >
                    <span
                      class="exclude-tagalys-css-reset search-product-price 
                        ${product.compare_at_price > product.price
                        ? 'search-product-price--sale'
                        : ''}"
                    >
                      ${helpers.formatCurrency(product.price)}
                    </span>

                    ${product.compare_at_price > product.price
                      ? html`
                          <s class="price-item price-item--slashed">
                            ${helpers.formatCurrency(product.compare_at_price)}
                          </s>
                        `
                      : ''}
                  </div>

                  <div
                    class="yotpo-widget-instance product-card__yotpo-widget-instance"
                    data-yotpo-instance-id="${window.__YOTPO_CONTEXT__
                      ?.instanceId || ''}"
                    data-yotpo-product-id="${product.id}"
                    data-yotpo-cart-product-id="${product.id}"
                    data-yotpo-section-id="${window.__YOTPO_CONTEXT__
                      ?.sectionId || ''}"
                  ></div>
                </div>

                <div
                  class=${!isDesktop
                    ? 'product-card__compare-holder exclude-tagalys-css-reset'
                    : 'product-card__compare-holder--desktop'}
                ></div>
              </div>
            `
          },
        },
      },
      callbacks: {
        afterEveryRender: function (helpers) {
          HeaderSearchController.checkTypeSuggestionAvailable(helpers)
          SearchUIController.restructureSuggestionsDOM()
          SearchUIController.handleAfterRender(helpers, this)
        },
        onSuccessfulAPICall: function (response, helpers) {
          SearchUIController.handleAPIResponse(helpers, this)
          return response
        },
        afterInitialRender: function (helpers) {
          SearchUIController.init(this, helpers)

          if (isShopifySuggestionsFailover) {
            HeaderSearchController.hideDefaultContent()
            return
          }

          Tagalys.UIWidgets.Recommendations.init(
            SEARCH_SELECTORS.recommendations,
            {
              recommendationId:
                window.__TAGALYS_CURRENCY_CONTEXT__?.recommendation,
              templates: {
                widget: {
                  labels: {
                    heading: 'Featured Products',
                  },
                  options: {
                    selector: SEARCH_SELECTORS.recommendations,
                    alignToSelector: SEARCH_SELECTORS.recommendations,
                    count: 6,
                    displayFormat: 'grid',
                  },
                  render: function (html, args) {
                    var props = args.props
                    var helpers = props.helpers
                    var products = helpers.getProducts()
                    if (props.loading === false) {
                      if (products.length === 0) {
                        return null
                      }
                      return html`
                        <div class="widget">
                          <${args.templates.header} />
                          <div class="widget-body">
                            <${args.templates.productList} />
                          </div>
                          <${args.templates.footer} />
                        </div>
                      `
                    }
                  },
                },

                header: {
                  render: function (html, args) {
                    var props = args.props
                    var apiResponse = props.helpers.getAPIResponse()
                    var widgetHeading =
                      args.labels.heading ||
                      (apiResponse ? apiResponse.title : '')
                    return html`
                      <div class="widget-header">
                        <div role="heading" aria-level="3">
                          ${widgetHeading}
                        </div>
                      </div>
                    `
                  },
                },

                products: {
                  render: function (html, args) {
                    var props = args.props
                    var products = props.helpers.getProducts()
                    return html`
                      <div
                        role="group"
                        aria-label=""
                        class=${`products ${props.className}`}
                      >
                        ${products.map(function (product) {
                          return html`
                            <${args.templates.product}
                              key=${product.id}
                              product=${product}
                            />
                          `
                        })}
                      </div>
                    `
                  },
                },

                product: {
                  callbacks: {
                    afterInitialRender: function (helpers, props) {
                      if (
                        window.yotpo &&
                        typeof window.yotpo.initWidgets === 'function'
                      ) {
                        window.yotpo.initWidgets()
                      }

                      if (
                        typeof window.yotpoWidgetsContainer?.initWidgets ===
                        'function'
                      ) {
                        window.yotpoWidgetsContainer?.initWidgets()
                      }
                    },
                  },

                  render: function (html, args) {
                    var { product, helpers } = args.props
                    const images = product.images?.slice(0, 3) || []

                    const productUrl = helpers
                      .getTemplateOptions('product')
                      .productPageUrl(product)

                    /* ✅ SAFE SPLIT FUNCTION */
                    const splitTitle = (title, value) => {
                      if (!value) return { before: title, after: '' }

                      // escape + flexible spacing
                      const escaped = value.replace(
                        /[.*+?^${}()|[\]\\]/g,
                        '\\$&'
                      )
                      const flexible = escaped.replace(/\s+/g, '\\s?')

                      const regex = new RegExp(
                        `(.*?)\\b${flexible}\\b(.*)`,
                        'i'
                      )
                      const match = title.match(regex)

                      if (!match) {
                        return { before: title, after: '' }
                      }

                      return {
                        before: match[1].trim(),
                        after: match[2].trim(),
                      }
                    }

                    let cleanTitle = product.title
                    let productSubtitle = ''

                    const caseDiameter =
                      product.metafields?.specs?.case_diameter?.value?.[0]
                    const bandMaterial =
                      product.metafields?.specs?.band_material?.value?.[0]

                    /* ✅ PRIORITY 1: case_diameter */
                    if (caseDiameter) {
                      const { before, after } = splitTitle(
                        product.title,
                        caseDiameter
                      )

                      cleanTitle = before

                      if (!after || before === after) {
                        productSubtitle = caseDiameter
                      } else {
                        productSubtitle = `${caseDiameter} ${after}`.trim()
                      }
                    } else if (bandMaterial) {
                      /* ✅ PRIORITY 2: band_material */
                      const { before, after } = splitTitle(
                        product.title,
                        bandMaterial
                      )

                      cleanTitle = before

                      if (!after || before === after) {
                        productSubtitle = bandMaterial
                      } else {
                        productSubtitle = `${bandMaterial} ${after}`.trim()
                      }
                    }

                    const colorsCount =
                      (product.metafields?.merchandise?.variants?.value
                        ?.length || 0) > 0
                        ? product.metafields.merchandise.variants.value.length +
                          1
                        : 0

                    const isDesktop = window.innerWidth >= 990

                    return html`
                      <div class="product-card">
                        <div
                          class="search-landing__results-item product-card__media-wrapper exclude-tagalys-css-reset"
                        >
                          ${(() => {
                            const badgeEntries = Object.entries(badge_map || {})
                              .map(([key, value]) => ({
                                key,
                                ...value,
                              }))
                              .sort(
                                (a, b) => (a.priority || 0) - (b.priority || 0)
                              )

                            const badges = []
                            let badgeCount = 0

                            for (const badge of badgeEntries) {
                              if (badgeCount >= 2) break

                              const hasTag = product.tags?.includes(
                                badge.tag_reference
                              )

                              if (!hasTag) continue

                              badges.push(html`
                                <div
                                  class="product-badge__item utility exclude-tagalys-css-reset"
                                  id="product-badge-${badge.key}"
                                  style="
          --badge-font-color:${badge.color};
          --badge-border-color:${badge.border_color};
          ${badge.background_color
                                    ? `--badge-background-color:${badge.background_color};`
                                    : ''}
        "
                                >
                                  ${badge.label
                                    ? html`
                                        <span class="product-badge__label"
                                          >${badge.label}</span
                                        >
                                      `
                                    : ''}
                                  ${badge.icon
                                    ? html`
                                        <span
                                          class="${badge.label
                                            ? 'product-badge__icon'
                                            : 'product-badge__icon product-badge__icon--no-label'}"
                                          style="
                  -webkit-mask:url(${badge.icon}) no-repeat center / contain;
                  mask:url(${badge.icon}) no-repeat center / contain;
                  background-color:${badge.color};
                  width:${badge.label ? 12 : 35}px;
                  height:${badge.label ? 12 : 35}px;
                  display:inline-block;
                "
                                        >
                                          <span style="opacity:0;">
                                            <img
                                              src="${badge.icon}"
                                              width="${badge.label ? 12 : 35}"
                                              height="${badge.label ? 12 : 35}"
                                            />
                                          </span>
                                        </span>
                                      `
                                    : ''}
                                </div>
                              `)

                              badgeCount++
                            }

                            if (!badges.length) return ''

                            return html`
                              <div
                                class="search-product-badge exclude-tagalys-css-reset"
                              >
                                ${badges}
                              </div>
                            `
                          })()}

                          <!-- SPLIDE START -->
                          <search-image-carousel>
                            <div
                              class="splide product-card__media-splide js-carousel-container"
                              role="group"
                              id="splide-${product.id}"
                            >
                              ${images.length > 1
                                ? html`
                                    <ul
                                      class="splide__pagination product-card__media-splide-pagination"
                                    ></ul>
                                  `
                                : ''}

                              <div class="splide__track">
                                <ul
                                  class="splide__list search-recomm-product-list"
                                >
                                  ${images.map((image, index) => {
                                    const isPng = /\.png(\?|$)/i.test(image.src)
                                    const imgClass = isPng
                                      ? 'product-card__image'
                                      : 'product-card__image product-card__image-jpg'

                                    const loading =
                                      index === 0 ? 'eager' : 'lazy'

                                    return html`
                                      <li
                                        class="splide__slide"
                                        key="${product.id}-${image.position}"
                                      >
                                        <a
                                          id="product-${product.id}-${image.position}"
                                          href="${productUrl}"
                                          aria-label="${image.alt ||
                                          product.title}"
                                          data-product-card-link
                                        >
                                          <div
                                            class="product-card__image-wrapper exclude-tagalys-css-reset"
                                          >
                                            <img
                                              src="${image.src}"
                                              width="400"
                                              height="500"
                                              class="${imgClass}"
                                              loading="${loading}"
                                              alt="${image.alt ||
                                              product.title}"
                                            />
                                          </div>
                                        </a>
                                      </li>
                                    `
                                  })}
                                </ul>
                              </div>

                              <div
                                class="splide__arrows product-card__media-splide-arrows 
                              ${images?.length > 1
                                  ? ''
                                  : 'product-card__media-splide-arrows-hide'}"
                              >
                                <button
                                  type="button"
                                  class="splide__arrow splide__arrow--prev button button--action-circle product-card__media-splide-arrow"
                                  aria-label="Previous"
                                >
                                  <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    aria-hidden="true"
                                  >
                                    <use
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xlink:href="#icon-arrow-left"
                                    ></use>
                                  </svg>
                                </button>
                                <button
                                  type="button"
                                  class="splide__arrow splide__arrow--next button button--action-circle product-card__media-splide-arrow"
                                  aria-label="Next"
                                >
                                  <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    aria-hidden="true"
                                  >
                                    <use
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      xlink:href="#icon-arrow-right"
                                    ></use>
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </search-image-carousel>
                          <!-- SPLIDE END -->

                          <div
                            class=${isDesktop
                              ? 'product-card__compare-holder'
                              : 'product-card__compare-holder--mobile'}
                          ></div>
                        </div>

                        <div class="product-card__details">
                          <a
                            class="search-landing__product-card-title exclude-tagalys-css-reset"
                          >
                            ${cleanTitle}
                          </a>

                          ${productSubtitle
                            ? html`<div
                                class="search-landing__product-card__subtitle exclude-tagalys-css-reset"
                              >
                                ${productSubtitle}
                                ${theme_style === 'guess' &&
                                colorsCount &&
                                !Number.isNaN(colorsCount)
                                  ? ` | ${colorsCount} Colors`
                                  : ''}
                              </div>`
                            : ''}

                          <div
                            class="search-landing__product-card-price exclude-tagalys-css-reset"
                          >
                            <span
                              class="exclude-tagalys-css-reset search-product-price 
                          ${product.compare_at_price > product.price
                                ? 'search-product-price--sale'
                                : ''}"
                            >
                              ${helpers.formatCurrency(product.price)}
                            </span>

                            ${product.compare_at_price > product.price
                              ? html`
                                  <s class="price-item price-item--slashed">
                                    ${helpers.formatCurrency(
                                      product.compare_at_price
                                    )}
                                  </s>
                                `
                              : ''}
                          </div>

                          <div
                            class="yotpo-widget-instance product-card__yotpo-widget-instance"
                            data-yotpo-instance-id="${window.__YOTPO_CONTEXT__
                              ?.instanceId || ''}"
                            data-yotpo-product-id="${product.id}"
                            data-yotpo-cart-product-id="${product.id}"
                            data-yotpo-section-id="${window.__YOTPO_CONTEXT__
                              ?.sectionId || ''}"
                          ></div>
                        </div>

                        <div
                          class=${!isDesktop
                            ? 'product-card__compare-holder exclude-tagalys-css-reset'
                            : 'product-card__compare-holder--desktop'}
                        ></div>
                      </div>
                    `
                  },
                },
              },
            }
          )
        },

        beforeAPICall: function (requestParams, helpers) {
          SearchUIController.handleBeforeAPI(helpers, this)
          return requestParams
        },
      },
    }

    function initializeShopifySearchSuggestions() {
      if (!Tagalys?.UIWidgets?.ShopifySearchSuggestions?.init) {
        return null
      }

      isShopifySuggestionsFailover = true
      HeaderSearchController.hideDefaultContent()

      var shopifySearchSuggestionsConfig = Object.assign(
        {},
        searchSuggestionsConfig
      )
      var shopifySearchSuggestionsTemplates = Object.assign(
        {},
        searchSuggestionsConfig.templates,
        {
          widget: Object.assign({}, searchSuggestionsConfig.templates.widget, {
            options: Object.assign(
              {},
              searchSuggestionsConfig.templates.widget.options,
              {
                sections: {
                  products: {
                    include: ['total_count', 'items'],
                    count: 12,
                  },
                  pages: {
                    count: 10,
                  },
                  queries: {
                    count: 10,
                  },
                },
              }
            ),
          }),
        }
      )

      shopifySearchSuggestionsConfig.templates =
        shopifySearchSuggestionsTemplates
      delete shopifySearchSuggestionsConfig.failover

      return Tagalys.UIWidgets.ShopifySearchSuggestions.init(
        SEARCH_SELECTORS.input,
        shopifySearchSuggestionsConfig
      )
    }

    searchSuggestionsConfig.failover = initializeShopifySearchSuggestions

    Tagalys.UIWidgets.SearchSuggestions.init(
      SEARCH_SELECTORS.input,
      searchSuggestionsConfig
    )
  })
}
